export default "__VITE_ASSET__D6mvZbO0__"